module.exports = require('./helpers/bundle-url').getBundleURL('lbB2N') + "gas-station-black-64.20704098.png";